import React, { useEffect } from 'react';
import PageTemplate from '../components/common/template/PageTemplate';

import WithLoading from '../Hoc/WithLoading';
import ReviewItemView from '../domain/Review/Item/ReviewItemView';
import { FriendPaybackBanner } from '../domain/friend-payback/FriendPayback';

export const getReviewItemApi = `/review/:id`;

const ReviewDetailPage = ({ id }) => {
  useEffect(() => {}, [id]);

  return (
    <PageTemplate title={'리뷰 상세'} noMargin>
      <WithLoading
        component={ReviewItemView}
        url={getReviewItemApi.replace(':id', id)}
      />
      <FriendPaybackBanner />
    </PageTemplate>
  );
};

export default React.memo(ReviewDetailPage);
